import { Component, inject } from '@angular/core';
import { ContentBlock, ContentBlockType, ContentEditorComponent } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { iframeResizer } from 'iframe-resizer';

export interface CommentBlock extends ContentBlock {
    content: string;
}

@Component({
    template: `
        <ng-container *ngIf="inEditor">
            <mat-icon class="help" matTooltip="This block is only visible in the editor. Useful for internal notes.">help</mat-icon>
            <div class="note" [innerHTML]="block.content | markdownToHtml | trustHtml"></div>
        </ng-container>
    `,
    styles: [
        `
        .help {
            float: right;
        }
        `
    ]
})
export class ViewComponent extends ContentBlockViewComponent<CommentBlock> {
    inEditor = !!inject(ContentEditorComponent, { optional: true });

    ngAfterViewInit() {
        setTimeout(() => {
            iframeResizer({ log: true }, 'iframe');
        }, 500);
    }
}

@Component({
    template: `
        <mat-form-field appearance="outline">
            <mat-label>Text</mat-label>
            <textarea name="html"
                matInput
                autosize
                style="min-height: 5em;"
                [(ngModel)]="block.content"
                [disabled]="locked"
                ></textarea>
            <mat-hint>This content is only visible in the editor</mat-hint>
        </mat-form-field>
    `,
    styles: [
        `
        mat-form-field {
            width: 100%;
        }
        `
    ]
})
export class EditorComponent extends ContentBlockEditorComponent<CommentBlock> {
}

export const COMMENT_BLOCK_TYPE: ContentBlockType<CommentBlock> = {
    id: 'note',
    label: 'Note (Hidden from viewers)',
    icon: 'code',
    template: {
        content: ''
    },
    preview: {
        content: `
            This is a note which is never shown to the user.
        `
    },
    previewSettings: {
        horizontalAlign: 'center',
        verticalAlign: 'center'
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
